import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Form } from "semantic-ui-react";

import { UserInput } from "../../../components";

class Number extends Component {
  constructor(props) {
    super(props);

    let label = "";
    let default_value = "";

    const { default_configuration } = this.props;

    if (default_configuration) {
      label = default_configuration.label || "";
      default_value = default_configuration.default_value || "";
    }

    this.state = {
      label,
      default_value,
    };
  }

  handleLabelInput = e => {
    this.setState({ label: e.target.value }, () => {
      this.props.handleQuestionElementUpdate(this.state);
    });
  };

  handleDefaultValueInput = e => {
    this.setState({ default_value: e.target.value }, () => {
      this.props.handleQuestionElementUpdate(this.state);
    });
  };

  render() {
    return (
      <div>
        <Form.Field>
          <UserInput label={this.props.t("label").message || "Label"} value={this.state.label} onChange={this.handleLabelInput} />
        </Form.Field>

        <Form.Field>
          <UserInput
            type="number"
            label={this.props.t("default_value").message || "Default valaue"}
            value={this.state.default_value}
            onChange={this.handleDefaultValueInput}
          />
        </Form.Field>
      </div>
    );
  }
}

export default withTranslation()(Number);
